<script setup lang="ts">
import { reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { api } from "../api";

const router = useRouter();
const form = reactive({ username: "", password: "" });
const loading = ref(false);
const error = ref("");

async function submit() {
  error.value = "";
  loading.value = true;
  try {
    const result = await api.login(form.username, form.password);
    if (result.mustChangePassword) {
      await router.replace("/change-password");
      return;
    }
    await router.replace("/");
  } catch (e) {
    error.value = (e as Error).message;
  } finally {
    loading.value = false;
  }
}
</script>

<template>
  <div class="login-page">
    <section class="login-story"><span class="eyebrow">WANJUBAIKE.CN</span><h1>一处登录，协同管理全部业务系统</h1><p>统一管理员和员工身份，集中配置商城、ERPNext、客服系统与小禾堂客服的访问权限；各系统继续保留自身业务边界。</p></section>
    <section class="login-panel"><div class="login-card"><h2>登录一体化工作台</h2><p class="muted">初版使用独立管理员账号，后续接入企业微信与 OIDC。</p><el-alert v-if="error" :title="error" type="error" :closable="false" show-icon style="margin:20px 0"/><el-form :model="form" label-position="top" @submit.prevent="submit"><el-form-item label="账号"><el-input v-model="form.username" autocomplete="username"/></el-form-item><el-form-item label="密码"><el-input v-model="form.password" type="password" show-password autocomplete="current-password" @keyup.enter="submit"/></el-form-item><el-button type="primary" :loading="loading" @click="submit">登录</el-button></el-form></div></section>
  </div>
</template>
